
























import Enumerable from "linq";
import { ElTable } from "element-ui/types/table";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IDrawableItemEditable } from "../../../IDrawableItemEditable";
import { DocumentSummary, Document, ItemSet } from "../../../../../../domain/document";
import { DomainRegistry } from "../../../../../../domain";
import { IItem, AbstractPlainTextItem, AbstractRichTextItem, instanceOfIDocumentDataDraggable } from "../../../../../../domain/document/items";
import { IFreeInputableObject, instanceOfIFreeInputableObject } from "../../../objects/IFreeInputableObject";
import { IDocumentDataDragParameter, DocumentDataDropManager } from "../../../../../dragging";

interface IDatum {
  name: string;
  text: string;
  param: IDocumentDataDragParameter;
}

@Component
export default class DocumentDataViewer extends Mixins() {
  @Prop()
  document: DocumentSummary;
  
  @Prop()
  source: IDrawableItemEditable;
    
  data() {
    return {
      items: null as IDatum[],
    };
  }
  items: IDatum[];

  $refs!: {
    table: ElTable,
  };

  get isLoading(): boolean {
    return this.document
        && !this.items;
  }

  mounted() {
    this.updateItems();
  }

  activated() {
    this.refreshTableLayout();
  }

  private refreshTableLayout(): void {
    this.$doWhenValid(t => t.doLayout(), this.$refs.table);
  }

  @Watch("document")
  onDocumentChanged(newValue: DocumentSummary, oldValue: DocumentSummary): void {
    this.updateItems();
  }

  async updateItems(): Promise<void> {
    this.items = this.document
      ? await this.createData()
      : null;
  }

  async createData(): Promise<IDatum[]> {
    const repository = DomainRegistry.document.getDocumentRepository();
    const document = await repository.getDocumentForQuotation(this.document.patientNo, this.document.id);
    return this.documentToData(document);
  }

  documentToData(document: Document): IDatum[] {
    return Enumerable.from(document.itemSets)
      .select(s => this.itemSetToData(s))
      .aggregate([], (s, i) => s.concat(i));
  }

  itemSetToData(itemSet: ItemSet): IDatum[] {
    return Enumerable.from(itemSet.items)
      .select(i => this.itemToDatum(i))
      .where(i => !!i)
      .toArray();
  }

  itemToDatum(item: IItem): IDatum {
    if (!(item instanceof AbstractPlainTextItem) && !(item instanceof AbstractRichTextItem)) {
      return null;
    }
    const text = item.text();
    if (!text) {
      return null;
    }
    return {
      name: item.getDisplayName(),
      text,
      param: this.toDocumentDataDragParameter(item),
    };
  }

  private toDocumentDataDragParameter(item: IItem): IDocumentDataDragParameter {
    const param = instanceOfIDocumentDataDraggable(item)
      ? item.toDocumentDataDragParameter()
      : null;
    
    if (param) {
      Object.freeze(param);
    }
    return param;
  }

  paste(value: string): void {
    if (this.isSourcePastable(this.source)) {
      this.source.pasteText(value);
    }
  }

  private isSourcePastable(source: any): source is IFreeInputableObject {
    return instanceOfIFreeInputableObject(source)
      && source.isFreeInputable
      && source.shouldInputFreeSelfOrAll;
  }

  onDragStart(event: DragEvent, value: string, param: IDocumentDataDragParameter): void {
    DocumentDataDropManager.parameter = param;
    
    event.dataTransfer.effectAllowed = "copy";
    event.dataTransfer.setData("text", value);
  }
}
